import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Plans } from './pages/Plans';
import { Contact } from './pages/Contact';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import { Refund } from './pages/Refund';
import { BroadbandLeadForm } from './pages/BroadbandLeadForm';
import { AdminLogin } from './pages/admin/AdminLogin';
import { AdminChangePassword } from './pages/admin/AdminChangePassword';
import { AdminLayout } from './components/AdminLayout';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { AdminPlans } from './pages/admin/AdminPlans';
import { AdminLeads } from './pages/admin/AdminLeads';
import { AdminSettings } from './pages/admin/AdminSettings';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Toaster } from './components/ui/sonner';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <ScrollToTop />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<><Navbar /><Home /><Footer /></>} />
          <Route path="/about" element={<><Navbar /><About /><Footer /></>} />
          <Route path="/services" element={<><Navbar /><Services /><Footer /></>} />
          <Route path="/plans" element={<><Navbar /><Plans /><Footer /></>} />
          <Route path="/contact" element={<><Navbar /><BroadbandLeadForm /><Footer /></>} />
          <Route path="/terms" element={<><Navbar /><Terms /><Footer /></>} />
          <Route path="/privacy" element={<><Navbar /><Privacy /><Footer /></>} />
          <Route path="/refund" element={<><Navbar /><Refund /><Footer /></>} />
          
          {/* Admin Auth Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/change-password" element={<AdminChangePassword />} />
          
          {/* Protected Admin Routes */}
          <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="plans" element={<AdminPlans />} />
            <Route path="leads" element={<AdminLeads />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Routes>
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;
